import { useCrisp } from "@/hooks/useCrisp";
import { Accordion, Button, Container, Stack, Title } from "@mantine/core";

export function HelpCenterPage() {
  const { openChatWithUserData } = useCrisp();
  return (
    <Container size="md" py="xl">
      <Stack gap="xl">
        <Title order={2} c="white" ta="center">
          자주 묻는 질문
        </Title>

        <Accordion
          variant="separated"
          radius="md"
          styles={(theme) => ({
            item: {
              backgroundColor: theme.colors.dark[6],
              border: `1px solid ${theme.colors.dark[4]}`,
              "&[data-active]": {
                backgroundColor: theme.colors.dark[5],
              },
            },
            control: {
              color: theme.white,
              "&:hover": {
                backgroundColor: theme.colors.dark[5],
              },
            },
            content: {
              color: theme.colors.gray[4],
            },
          })}
        >
          <Accordion.Item value="item-1">
            <Accordion.Control>오프는 어떤 서비스인가요?</Accordion.Control>
            <Accordion.Panel style={{ whiteSpace: "pre-line" }}>
              {`OFF는 매주 수요일, 새로운 사람들과 저녁을 함께하는 소셜 네트워킹 서비스예요.

              단순한 식사가 아니라 취향 으로 연결되는 새로운 네트워킹 문화예요.`}
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="item-2">
            <Accordion.Control>오프에 포함된 서비스는?</Accordion.Control>
            <Accordion.Panel style={{ whiteSpace: "pre-line" }}>
              {`OFF의 큐레이터가 취향 테스트, 레스토랑 예약, 일정 안내를 모두 준비해요.

              저녁 식사 전 까지 저녁식사에 대한 정보가 순차적으로 공개됩니다.`}
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="item-3">
            <Accordion.Control>언제 어디서 열리나요?</Accordion.Control>
            <Accordion.Panel style={{ whiteSpace: "pre-line" }}>
              {`매주 수요일 저녁, 서울의 다양한 공간에서 열립니다. (오프는 계속해서 확장중..!)

              디테일한 정보는 예약후 순차적으로 공개됩니다!`}
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="item-4">
            <Accordion.Control>오프에는 어떤 사람들이 참여하나요?</Accordion.Control>
            <Accordion.Panel style={{ whiteSpace: "pre-line" }}>
              {`디자이너, 마케터, 개발자, 학생, 여행가, 아티스트, 크리에이터, 스타트업 창업가, 프리랜서 등 다양한 분야 의 사람들이 오프에 모여요.`}
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="item-5">
            <Accordion.Control>그룹은 어떻게 매칭되나요?</Accordion.Control>
            <Accordion.Panel style={{ whiteSpace: "pre-line" }}>
              {`취향 테스트 응답을 고려 하여 잘 맞을 수 있는 최적의 그룹을 구성해요.`}
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="item-6">
            <Accordion.Control>레스토랑은 어떻게 고르나요?</Accordion.Control>
            <Accordion.Panel style={{ whiteSpace: "pre-line" }}>
              {`취향 테스트와 대화하기 좋은 분위기를 고려해, 큐레이터가 직접 방문하고 엄선해요.`}
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="item-7">
            <Accordion.Control>어떻게 참여 예약하나요?</Accordion.Control>
            <Accordion.Panel style={{ whiteSpace: "pre-line" }}>
              {`간단해요! 취향 테스트를 하면, OFF가 딱 맞는 그룹을 큐레이팅해 드려요.

그리고 수요일 저녁, 공개된 레스토랑에서 새로운 사람들과 만나요.`}
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="item-8">
            <Accordion.Control>어떻게 참여 예약하나요?</Accordion.Control>
            <Accordion.Panel style={{ whiteSpace: "pre-line" }}>
              {`예약 확정 후 확정 문자를 보내드려요.

그리고 순차적으로 매칭된 그룹과 큐레이팅 장소에 대한 힌트들이 순차적으로 공개됩니다!`}
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="item-9">
            <Accordion.Control>만약 어색하면 어떻게 하죠?</Accordion.Control>
            <Accordion.Panel style={{ whiteSpace: "pre-line" }}>
              {`대화의 시작을 도울 수 있는 이야기 가이드가 준비되어 있어요.

오프의 큐레이터들은 어색하지 않게 대화에 몰입할 수 있도록 큐레이팅하고 있으니 걱정하지 마세요.`}
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>

        <Button
          size="lg"
          radius="md"
          variant="outline"
          color="gray"
          onClick={openChatWithUserData}
          styles={(theme) => ({
            root: {
              color: theme.white,
              "&:hover": {
                backgroundColor: "transparent",
              },
            },
          })}
        >
          고객센터 문의하기
        </Button>
      </Stack>
    </Container>
  );
}
